import { Trans, useTranslation } from 'react-i18next'
import { Form, useNavigate } from 'react-router-dom'
import appStoreAppOfTheYear2023 from '../../assets/app_store_app_of_the_day_2023.webp'
import googleEditorsChoice2023 from '../../assets/google_editors_choice_2023.webp'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import PageLayout from '../../components/PageLayout'

export default function CompanyPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/sign-up/password')
  }

  return (
    <PageLayout>
      <div className="flex grow flex-col">
        <div className="shrink-0">
          <Heading title={t('pages.signUp.company.heading')} />
        </div>

        <div className="flex grow flex-col justify-center space-y-8">
          <div className="flex items-center justify-center space-x-5">
            <img
              alt={t('pages.signUp.company.appStoreAppOfTheYear2023')}
              className="w-36"
              src={appStoreAppOfTheYear2023}
            />

            <img
              alt={t('pages.signUp.company.googleEditorsChoice2023')}
              className="w-36"
              src={googleEditorsChoice2023}
            />
          </div>

          <div className="space-y-2 text-center">
            <p className="font-headline text-2xl">
              {t('pages.signUp.company.andHas')}
            </p>

            <p className="font-headline text-2xl">
              <Trans
                components={{
                  colored: <span className="text-primary" />,
                }}
                i18nKey="pages.signUp.company.activeSubscribers"
              />
            </p>

            <p className="text-2xl tracking-wider">⭐️⭐️⭐️⭐️⭐️</p>
          </div>
        </div>

        <div className="shrink-0">
          <Form method="post" onSubmit={handleSubmit}>
            <Button
              title={t('shared.continue')}
              type="submit"
              dataTestId="button-continue"
            />
          </Form>
        </div>
      </div>
    </PageLayout>
  )
}
